





























































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import PageHeader from '../../../components/vui-luma/Ui/PageHeader.vue';
import PageSeparator from '../../../components/vui-luma/Ui/PageSeparator.vue';
import CustomSelectInput from '../../../components/vui-luma/Ui/CustomSelectInput.vue';
import MdIcon from '../../../components/vui-luma/Ui/MdIcon.vue';
import {
  dispatchAddFlows,
  dispatchCheckLandingUniqueName,
  dispatchDeleteFlow,
  dispatchGetFlows,
  dispatchUpdateFlows,
} from '@/store/user_flows/actions';
import {readFlows} from '@/store/user_flows/getters';
import mainFields from './fields';
import {store} from '@/store';
import {dispatchGetUserProfile} from '@/store/main/actions';

@Component({
  components: {
    PageHeader,
    PageSeparator,
    MdIcon,
    CustomSelectInput,
  },
})
export default class UserFlows extends Vue {
  public flow = null;
  public perPage = 10;
  public currentPage = 1;
  public addFlowVisible = false;
  public mainFields = mainFields;

  public fieldsNames: any = [];

  public async mounted() {
    this.fieldsNames = [
      {
        key: 'title',
        // @ts-ignore
        label: this.$t('Title'),
        sortable: true,
        thClass: 'text-right',
        tdClass: 'text-right',
      }, {
        key: 'flow_messages_name',
        // @ts-ignore
        label: this.$t('Messages flow'),
        sortable: true,
        thClass: 'text-right',
        tdClass: 'text-right',
      }, {
        key: 'landing_template_name',
        // @ts-ignore
        label: this.$t('Landing template'),
        sortable: true,
        thClass: 'text-right',
        tdClass: 'text-right',
      }, {
        key: 'landing.slug',
        // @ts-ignore
        label: this.$t('Unique name'),
        sortable: true,
        thClass: 'text-right',
        tdClass: 'text-right',
      }, {
        key: 'chatbot_type',
        // @ts-ignore
        label: this.$t('Chatbot type'),
        sortable: true,
        thClass: 'text-right',
        tdClass: 'text-right',
      }, {
        key: 'params',
        label: '',
        thClass: 'text-right',
        tdClass: 'text-right',
      },
    ];
    await dispatchGetFlows(this.$store);
    const flows = readFlows(this.$store);
  }

  get flows() {
    return readFlows(this.$store);
  }

  public rows() {
    return this.flows.length;
  }

  public resetForm() {
    this.addFlowVisible = false;
    // @ts-ignore
    this.$refs.flowForm.reset();
    for (const [key, item] of Object.entries(mainFields)) {
      item.error = false;
    }
  }

  public async validateForm() {
    let isValid = true;

    for (const [key, item] of Object.entries(mainFields)) {
      if (item.required) {
        // @ts-ignore
        if (!document.getElementById(`${item.id}`).value) {
          item.error = true;
          isValid = false;
        } else {
          item.error = false;
        }
      }
    }
    return isValid;
  }

  public async submitFlowForm() {
    if (await this.validateForm()) {
      const formData = new FormData();
      // @ts-ignore
      const elements = this.$refs.flowForm.elements;
      // @ts-ignore
      for (const [key, item] of Object.entries(elements)) {
        // @ts-ignore
        if (item.name !== undefined) {
          // @ts-ignore
          if (item.type === 'checkbox') {
            // @ts-ignore
            formData.append(item.name, item.checked ? item.checked : '');
          } else {
            // @ts-ignore
            formData.append(item.name, item.value ? item.value : '');
          }
        }
      }
      if (this.flow) {
        await dispatchUpdateFlows(
          this.$store,
          {
            // @ts-ignore
            id: this.flow.id,
            data: formData,
          },
        );
      } else {
        await dispatchAddFlows(
          this.$store,
          {
            data: formData,
          },
        );
      }
      this.resetForm();
      await dispatchGetUserProfile(this.$store);
    }
  }

  public copyLink(id) {
    const codeToCopy = document.querySelector(`#chatbot-link-${id}`);
    // @ts-ignore
    codeToCopy.setAttribute('type', 'text');
    // @ts-ignore
    codeToCopy.select();

    try {
      document.execCommand('copy');
      // @ts-ignore
      this.$noty.error(this.$t('Link copied'));
    } catch (err) {
      // @ts-ignore
      this.$noty.error(this.$t('Copy error'));
    }

    // @ts-ignore
    codeToCopy.setAttribute('type', 'hidden');
    // @ts-ignore
    window.getSelection().removeAllRanges();
  }

  public handleEditModal(flow) {
    this.flow = flow;
  }

  public handleAddModal() {
    this.flow = null;
  }

  public async flowDelete(id) {
    // @ts-ignore
    if ( confirm(this.$t('Delete flow?')) ) {
      await dispatchDeleteFlow(this.$store, {id});
    }
  }

  public async checkUniqueName() {
    const landingSlug = document.getElementById('landing_slug');
    const data = {
      // @ts-ignore
      landing_pk: this.flow !== null && this.flow.landing !== null ? this.flow.landing.id : '',
      // @ts-ignore
      name: landingSlug.value,
    };
    const result = await dispatchCheckLandingUniqueName(this.$store, {data});
    let error = false;
    let errorMessage = '';
    if (result.matches) {
      error = true;
      errorMessage = result.error;
    }
    for (const [key, item] of Object.entries(mainFields)) {
      if (item.id === 'landing_slug') {
        item.error = error;
        item.errorMessage = errorMessage;
      }
    }
  }

}
